// extracted by mini-css-extract-plugin
export default {"wrap":"lN7IGT","title":"WPotmZ","subtitle":"NDi_TS","description":"Xrm6Ru","calculator":"kUhfZR","frame":"o0hhHV","frameMobile":"zfqtG5"};